import { useEffect, useState } from "react";
import * as masterServices from "../services/masterServices";
import useValue from "./useValue";
import { CustomNotification } from "../util/CustomNotification";

import type FixMeLater from "../shared/types/fixMeLater.type";
import { General } from "../util/General";

const useGetOneMasterList = (moduleId: number) => {
  /* CONSTANTS */

  /* STATES */
  const [masterList, setMasterList] = useState<FixMeLater[]>([]);
  const [reFetchList, setRefetchList] = useState(General.getGUID());

  /* CUSTOM HOOKS */
  const { value: loading, handleDisableValue: handleDisableLoading, handleEnableValue: handleEnableLoading } = useValue(true);

  /* HANDLERS */
  const handleRefetchList = () => setRefetchList(General.getGUID());

  /* EFFECTS */
  useEffect(() => {
    const fetchData = async () => {
      handleEnableLoading();

      const response = await masterServices.getOneMasterListById(moduleId);
      return response;
    };

    fetchData()
      .then((response) => {
        const filteredRecords = response["AllRecordsList"];
        setMasterList(filteredRecords);
      })
      .catch((error) => {
        CustomNotification.showErrorMessage(error);
      })
      .finally(() => {
        handleDisableLoading();
      });
    // eslint-disable-next-line
  }, [reFetchList]);

  return { masterList, loading, handleRefetchList };
};

export default useGetOneMasterList;
